import React from 'react';
import './Background.css';

const Background = () => {
    return (
        <div className="global-background">
            <div className="bubble bubble-1"></div>
            <div className="bubble bubble-2"></div>
            <div className="bubble bubble-3"></div>
            <div className="bubble bubble-4"></div>
            <div className="bubble bubble-5"></div>
            <div className="bubble bubble-6"></div>
        </div>
    );
};

export default Background;
